import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

import { DialogOptions } from '../dialog/types';

@Component({
  selector: 'confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent implements OnChanges {
  @Input() header: string = 'Подтверждение';
  @Input() visible: boolean = false;
  @Output() result: EventEmitter<boolean> = new EventEmitter();

  options: DialogOptions<any> = {
    visible: this.visible,
    maximizable: false,
    header: this.header,
    acceptButton: 'Да',
    rejectButton: 'Нет',
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['header']) {
      this.mergeOptions({ header: this.header });
    }

    if (changes['visible']) {
      this.mergeOptions({ visible: this.visible });
    }
  }

  onAccept() {
    this.result.emit(true);
    this.mergeOptions({ visible: false });
  }

  onReject() {
    this.result.emit(false);
    this.mergeOptions({ visible: false });
  }

  open(options: DialogOptions<any>) {
    options.visible = true;
    this.mergeOptions(options);
  }

  private mergeOptions(options: DialogOptions<any>) {
    this.options = {
      ...this.options,
      ...options,
    };
  }
}
